export function offset(el, parent) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = parent ? parent.scrollLeft : window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = parent ? parent.scrollTop : window.pageYOffset || document.documentElement.scrollTop;
    return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
}

export function getScrollOffset(el, parent, header) {
    let headerHeight = header ? header.offsetHeight : 0;

    return Math.max(0, offset(el, parent).top - headerHeight - 30);
}

function supportsPassive() {
    let supportsPassive = false;

    try {
        let opts = Object.defineProperty({}, 'passive', {
            get: function() {
                supportsPassive = true;
            }
        });
        window.addEventListener("testPassive", null, opts);
        window.removeEventListener("testPassive", null, opts);
    } catch (e) {}

    return supportsPassive;
}

export function scrollWithOffset(el, parent, header, extraOffset = 0) {
    return new Promise((resolve, reject) => {
        let container = parent ? parent : window,
            topPosition = getScrollOffset(el, parent, header) + extraOffset,
            top = topPosition.toFixed(),
            onScroll = () => {
                let scrollTop = parent ? parent.scrollTop : (window.pageYOffset || document.documentElement.scrollTop)
                if (scrollTop.toFixed() === top) {
                    container.removeEventListener('scroll', onScroll)
                    resolve();
                }
            };

        container.addEventListener('scroll', onScroll, supportsPassive() ? {passive: true} : false);
        container.scrollTo({top: topPosition, left: 0, behavior: 'smooth'});
    });
}

(function() {
    /*
     * CustomEvent polyfill
     */
    if (typeof window.CustomEvent !== 'function') {
        function CustomEvent(event, params) {
            params = params || {bubbles: false, cancelable: false, detail: null};
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        window.CustomEvent = CustomEvent;
    }
})();

export function triggerEvent($el, eventName, data, bubbles = true) {
    let event = new CustomEvent(eventName, {
        bubbles: bubbles,
        cancelable: true,
        detail: data
    });
    $el.dispatchEvent(event);
}

export function toggleBodyScroll(doLock) {
    let $topBar = document.getElementById('top-bar');

    if (doLock) {
        let _cacheScrollTop = window.pageYOffset || document.documentElement.scrollTop,
            scrollBarWidth = window.innerWidth - document.body.clientWidth + 'px';

        document.body.dataset['scrollTop'] = `${_cacheScrollTop}`;
        document.body.style.top = -_cacheScrollTop + 'px';
        document.body.style.paddingRight = scrollBarWidth;
        $topBar.style.right = scrollBarWidth;
        document.body.classList.add('no-scroll');
    } else {
        let _cacheScrollTop = parseFloat(document.body.dataset['scrollTop'] || '0');

        document.body.classList.remove('no-scroll');
        document.body.style.top = '';
        document.body.style.paddingRight = '';
        $topBar.style.right = '';
        window.scrollTo(0, _cacheScrollTop);
    }
}

export function storageAvailable(type) {
    try {
        let storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return false;
    }
}

export function checkVerticalresize(previousWidth, callback) {
    if (previousWidth !== document.documentElement.clientWidth) {
        if (typeof callback === 'function') {
            callback();
        }
    }
}

export function getHeight($element, fullClassname, timeout = 200, callback) {
    let height;

    $element.classList.add(fullClassname);
    $element.classList.add('no-animation');
    height = $element.offsetHeight;
    if (typeof callback === 'function') {
        callback($element);
    }
    $element.classList.remove(fullClassname);
    setTimeout(() => {
        $element.classList.remove('no-animation');
    }, timeout);

    return height;
}

export function getFromTemplate(htmlString) {
    let div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

export function parseItem(itemData, itemTemplate) {
    let itemHtml = itemTemplate;

    for (let param in itemData) {
        if (itemData.hasOwnProperty(param)) {
            let regexp = new RegExp(`\\[${param}\\]`, 'g');

            itemHtml = itemHtml.replace(regexp, itemData[param]);
        }
    }

    return itemHtml;
}

export function renderItem(itemData, itemTemplate) {
    return getFromTemplate(parseItem(itemData, itemTemplate));
}

export function wrap(toWrap, wrapper) {
    wrapper = wrapper || document.createElement('div');
    toWrap.insertAdjacentElement('afterend', wrapper);
    wrapper.appendChild(toWrap);
    return wrapper;
}



// WEBPACK FOOTER //
// ./sources/js/base/utils.js